import { Input } from "src/features/calculator/types/formula"

const BASE_TAX_MULTIPLIER = 1
const ROUNDING_DECIMALS = 2
// 手数料割引
// 送客手数料率(税込) = 割引後送客手数料率(税抜) x ( 1 + 消費税率 ))
export function calcCustomerTransferFeeRate({
  exDiscountedCustomerTransferFeeRate,
  consumptionTaxRate,
}: Input): number {
  const customerTransferFeeRate =
    exDiscountedCustomerTransferFeeRate * (BASE_TAX_MULTIPLIER + consumptionTaxRate)
  return parseFloat(customerTransferFeeRate.toFixed(ROUNDING_DECIMALS))
}
